export default __webpack_public_path__ + "static/media/Minicard_Kh.bffb0358.svg";